export default {
  control: (provided, state) => {
    return {
      ...provided,
      "cursor": "pointer",
      "box-shadow": "none"
    }
  },
  indicatorSeparator: (provided, state) => ({ ...provided, display: "none" }),
  menuList: (provided, state) => {
    return {
      ...provided,
      "padding": "0",
      "border-radius": "4px"
    }
  },
  option: (provided, state) => {
    const { data: { __isNew__ } } = state;
    let styles;

    if (__isNew__) {
      styles = {
        "margin": "16px",
        "background-color": "#c8bdfc",
        "border-radius": "8px",
        "font-weight": "bold",
        "font-size": "16px",
        "line-height": "22px",
        "color": "#FFFFFF",
        "box-sizing": "border-box",
        "width": "auto",
        "padding": "9px 10px"
      }
    }
    else { styles = {} }

    return {
      ...provided,
      ...styles,
      "color": state.isFocused ? "white" : "black",
      "background-color": state.isFocused ? "#d6ccff" : "white"
    }
  },
  dropdownIndicator: (provided, state) => {
    return {
      ...provided,
      "color": "black"
    }
  },
  menuPortal: (provided, state) => {
    return {
      ...provided,
      "z-index": "10"
    }
  }
}
